import { render } from "./FaqPopUp.vue?vue&type=template&id=43574078&scoped=true"
import script from "./FaqPopUp.vue?vue&type=script&lang=js"
export * from "./FaqPopUp.vue?vue&type=script&lang=js"

import "./FaqPopUp.vue?vue&type=style&index=0&id=43574078&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43574078"]])

export default __exports__